import VideoSnapshot from 'video-snapshot';
export const getVideoDimensionsFromBlob = async (blob, snapshoter = new VideoSnapshot(blob)) => {
  try {
    return await snapshoter.getDimensions();
  } finally {
    snapshoter.end();
  }
};